import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
    '/administration/integrations/_webhooks/webhook/token-configurations',
)({
    beforeLoad: () => {
        throw redirect({ to: '/administration/integrations/webhook/subscribers', replace: true })
    },
})
